import { render, staticRenderFns } from "./estimate-rates.vue?vue&type=template&id=12b7f284&scoped=true"
import script from "./estimate-rates.vue?vue&type=script&lang=js"
export * from "./estimate-rates.vue?vue&type=script&lang=js"
import style0 from "./estimate-rates.vue?vue&type=style&index=0&id=12b7f284&prod&lang=css"
import style1 from "./estimate-rates.vue?vue&type=style&index=1&id=12b7f284&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b7f284",
  null
  
)

export default component.exports